import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'

@Component({
  selector: 'ftr-selectable-id',
  templateUrl: './selectable-id.component.html',
  styleUrl: './selectable-id.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableIdComponent {
  readonly id = input.required<Uuid>()

  readonly selected = output<Uuid>()

  protected readonly shortId = computed(() => this.id().slice(0, 8))
}
